import React, {Component} from 'react';

import ToggleInput from "../../../../components/ToggleInput/toggleInput";

export default class MeterView extends Component {

    render() {

        let meter = this.props.item;
        if(!meter){return <div />}

        return (
            <div className={"admin-modal"}>
                <div className={"row"}>
                    <h3 className={"center"}>Meter {meter.code}</h3>
                </div>
                <div className={"row thin-row"}>
                    <div className={"col s12 input-field"}>
                        <label className="active">Description</label>
                        <p className={"field-p"}>{meter.description}</p>
                    </div>
                </div>
                <div className={"row thin-row"}>
                    <div className={"col s12 input-field"}>
                        <label className="active">Product</label>
                        <p className={"field-p"}>{meter.product.name}</p>
                    </div>
                </div>
                <div className={"row "}>
                    <div className={"col s12 input-field"}>
                        <label className="active">Isla de Descarga</label>
                        <p className={"field-p"}>{meter.loading_island.name}</p>
                        <ToggleInput
                            selected={meter.active}
                            name={'¿Meter activo?'} />
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 center"}>
                        <button
                            className={"btn btn-shell-empty z-depth-0"}
                            onClick={this.props.closeAction}
                        >Cancelar</button>
                        <button
                            className={"btn btn-shell z-depth-0"}
                            onClick={() => this.props.editAction(meter, 'edit')}
                        >Editar</button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/Modals/MeterView.js